import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Button';
import { FiAlertCircle, FiInfo } from 'react-icons/fi';

const GlobalModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'error', // 'error' or 'info'
    onConfirm: null,
    showCancel: false,
  });

  useEffect(() => {
    const handleShowModal = (event) => {
      setModalState({
        isOpen: true,
        title: event.detail.title || 'Notification',
        message: event.detail.message || '',
        type: event.detail.type || 'error',
        onConfirm: event.detail.onConfirm || null,
        showCancel: event.detail.showCancel || false,
      });
    };

    window.addEventListener('showGlobalModal', handleShowModal);

    return () => {
      window.removeEventListener('showGlobalModal', handleShowModal);
    };
  }, []);

  const handleClose = () => {
    setModalState({
      isOpen: false,
      title: '',
      message: '',
      type: 'error',
      onConfirm: null,
      showCancel: false,
    });
  };

  const handleConfirm = () => {
    if (modalState.onConfirm) {
      modalState.onConfirm(true);
    }
    handleClose();
  };

  const handleCancel = () => {
    if (modalState.onConfirm) {
      modalState.onConfirm(false);
    }
    handleClose();
  };

  const Icon = modalState.type === 'error' ? FiAlertCircle : FiInfo;
  const iconColor = modalState.type === 'error' ? 'text-error' : 'text-primary';
  const iconBg = modalState.type === 'error' ? 'bg-error/10' : 'bg-primary/10';

  return (
    <Modal
      isOpen={modalState.isOpen}
      onClose={handleClose}
      title={modalState.title}
      size="md"
      footer={
        <div className="flex gap-3">
          {modalState.showCancel && (
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
          )}
          <Button onClick={handleConfirm}>
            {modalState.showCancel ? 'OK' : 'OK'}
          </Button>
        </div>
      }
    >
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className={`w-12 h-12 ${iconBg} rounded-full flex items-center justify-center`}>
            <Icon className={`w-6 h-6 ${iconColor}`} />
          </div>
        </div>
        <div className="flex-1">
          <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">
            {modalState.message}
          </p>
        </div>
      </div>
    </Modal>
  );
};

// Helper function to show modal from anywhere
export const showGlobalModal = (options) => {
  const event = new CustomEvent('showGlobalModal', { detail: options });
  window.dispatchEvent(event);
};

export default GlobalModal;

